import type PaginationResultApiModel from '../../../services/pagination-result.api-model';
import type { IPaginationResult } from '../../../models/pagination-result.model';
import type IPressMaterial from '../../../models/press/press-material.model';
import { PressMaterialApiModel } from './press-material.api-model';

export class PressMaterialsApiModel {
  public static mapToBusinessModel(apiModel: PaginationResultApiModel<PressMaterialApiModel>): IPaginationResult<IPressMaterial> {
    return {
      results: apiModel.results.map(PressMaterialApiModel.mapToBusinessModel),
      count: apiModel.count,
      totalCount: apiModel.totalCount,
      links: {
        current: apiModel.links?.current,
        next: apiModel.links?.next,
        previous: apiModel.links?.previous,
      },
    };
  }
}

